import { useEffect, useState } from "react";
import Tabs from "../../../../Components/Tabs";
import GetIcon from "../../../../utils/Icon";
import { useLocation, useNavigate } from "react-router-dom";
import Tab1 from "./Tab1";
import Table from "./Table";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import { usePostActiveSNoPutAwayMutation, usePostPutawayCreationMutation, usePostPutawaySubmitMutation } from "../../../../store/api/putawayapi";
import { useGetNotSaveScreenMutation, useGetWarehouseListMutation, usePostPurchaseOrderIDMutation } from "../../../../store/api/purchaseorderapi";
import { createNewDistributionForItem, createNewDistributionForSerialItem, findExistingRowForItem, findExistingRowForSerialItem, findSerializedItemMatch, findUndistributedItemRow, findUndistributedSerialRow, getNonSerialItemsForCode, getSerialItemsForCode, isItemFullyDistributed, updateExistingItemRow, updateExistingSerialRow, validateBinScan } from "../Helper/Helper";
import Attachment from "../../../../utils/Attachment";
import { useGetDoctypeDetailsQuery } from "../../../../store/api/itemapi";

const PurchaseForm = () => {
  const nvg = useNavigate()
  const reallocation = useLocation();
  const [location, setlocation] = useState(reallocation?.state?.Grn ? reallocation : {})
  const [grnlist, setgrnlist] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [finalstep, setfinalstep] = useState(false);
  const [selectedgrn, setselectedgrn] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [tab, settab] = useState(1)
  const [item_Rows, setitem_Rows] = useState([]);
  const [ptype, setptype] = useState("Error")
  const [error, setError] = useState('');
  const [showError, setShowError] = useState(false);
  const [loader, setloader] = useState(true);
  const [completeData, setcompleteData] = useState({});
  const [put_response, setput_response] = useState("");
  const [warehouse_list, setwarehouse_list] = useState([]);
  const [scannedSerial, setscannedSerial] = useState([]);
  const [activityboll, setactivityboll] = useState(false);
  const [scannedBin, setScannedBin] = useState('');
  const [scannedItem, setScannedItem] = useState('');
  const [currentSelectRow, setCurrentSelectRow] = useState(null);
  const [currentBin, setCurrentBin] = useState(null);
  const [getAllPO] = usePostPurchaseOrderIDMutation();
  const [submit_putaway] = usePostPutawaySubmitMutation()
  const [NotSaveScreenApi] = useGetNotSaveScreenMutation();
  const [getwarehouse_data] = useGetWarehouseListMutation()
  const [create_putaway] = usePostPutawayCreationMutation()
  const [GetActiveSerialNOPutAway] = usePostActiveSNoPutAwayMutation();
  const [scannedItemCode, setScannedItemCode] = useState(null);
  
  useEffect(()=>{
  if(reallocation?.state?.Grn){
    setlocation(reallocation);
  }
  },[location])
  useEffect(() => {
  const getdata = async () => {
    const response = await NotSaveScreenApi({
      "method": "erpnext.stock.doctype.purchase_receipt.purchase_receipt.make_stock_entry",
      "source_name": location.state.Grn
    });

    setcompleteData(response.data.message);
    setItemList(response.data.message.items);
    
    const serialPromises = response.data.message?.items.map(item => 
      getserialno(item.item_code)
    );
    
    const allSerialNumbers = await Promise.all(serialPromises);
    
    const updatedRows = response.data.message?.items.map((item, index) => ({
      ...item,
      id: `${item.item_code}-${Date.now()}`,
      originaldata: true,
      grn_qty: item.received_qty,
      scan_qty: 0,
      new_bin: '',
      accepted_qty: '',
      rejected_qty: '',
      expiry_date: '',
      manufacturing_date: '',
      serial_no_used:[],
      serial_numbers: allSerialNumbers[index],
      batch_no: item.batch_no,
    }));
    
    setitem_Rows(updatedRows);
    setloader(false);
  }
console.log("location locatiom",location);
  if(location.state){
  if (location.state.Grn && location.state.itemwithSerialNo) {
    setselectedgrn(location?.state?.Grn)
    getdata();
  }
}
  }, [location, NotSaveScreenApi]);

  useEffect(() => {
    const Warehouse = async () => {
      const warehouseApiData = await getwarehouse_data();
      setwarehouse_list(warehouseApiData.data.result);
    }
    Warehouse()
  }, [])


    useEffect(()=>{

       const getpofun = async () =>{

         const formData = new FormData();
         formData.append("doctype", "Purchase Receipt");
         formData.append("fields", JSON.stringify(["name"]));
         formData.append("filters", JSON.stringify([["Purchase Receipt","status","=","To Bill"],["Purchase Receipt","is_return","=",0],["Purchase Receipt","intozi_status","is","not set"]]));
         formData.append("order_by", "modified desc");
         formData.append("view", "List");
         formData.append("start",0);
         formData.append("view",9999999);


         const getpo = await getAllPO(formData);
        const names = getpo?.data?.message?.values.map((item) => ({ name: item[0] }));
         setgrnlist(names)
        }

        getpofun();
  
  },[])


  const { data: fulldata, isLoading } = useGetDoctypeDetailsQuery({ "doctype": "Purchase Receipt", "name": selectedgrn });

  useEffect(()=>{
     console.log("check clg")
       const redirecttoPutaway = async () =>{
         const response = await GetActiveSerialNOPutAway({"receipt_id":selectedgrn});
          console.log("response os response ffff",response);
          let itemlist = response?.data?.result?.items;    
           setlocation({ state: {
            Grn:selectedgrn,
            supplier:fulldata?.message?.supplier,
            po:fulldata?.message?.items?.[0]?.purchase_order,
            itemwithSerialNo:item_Rows.map(item => ({
               item_code: item.item_code,
               received_qty: Number(item.accepted_qty),
               serial_nos: itemlist?.find(serial_item => serial_item.item_code === item.item_code)?.unused_serial_no,
               batch_no: item.batch_no,
             }))} });
       }
       if(selectedgrn){
         redirecttoPutaway();
       }else{
        setcompleteData({});
        setItemList([]);
        setitem_Rows([]);
        setlocation({ state: {
            Grn:'',
            supplier:'',
            po:'',
            itemwithSerialNo:[]
          }
         })
       }
  },[selectedgrn,fulldata])

   const getserialno = async(itemcode) =>{
    if(location.state.itemwithSerialNo){
      const serialNos = location.state.itemwithSerialNo.filter((item) => item.item_code == itemcode);
     if(serialNos?.[0]?.serial_nos?.length > 0){
       return serialNos[0].serial_nos;
     }else{
      return []
     }
    }
  }

  const handleBinScan = (binName) => {
    const bin = warehouse_list.find(wh =>
      wh.name.toLowerCase() === binName.toLowerCase()
    );
    if (!bin) {
      setError(`Bin "${binName}" not found`);
      setShowError(true);
      return false;
    }

    setCurrentBin(bin);
    setTimeout(() => {
      document.getElementById('item-scan-input')?.focus();
    }, 500);
    return true;
  };

  const checkItemData = async () =>{
     const response = await GetActiveSerialNOPutAway({"receipt_id":location.state.Grn});
     return response;
  }

  const handleItemScan = async (itemCode) => {
    // Validate bin scan first
    if (!validateBinScan(currentBin, scannedBin, setError, setShowError)) return;
    const checkSerialThroughApi = await checkItemData();
    setitem_Rows(prevRows => {
      // Check if this is a serialized item
      const serialMatchRow = findSerializedItemMatch(prevRows, itemCode);    
      if (serialMatchRow) {
        const apiscannedSerial = checkSerialThroughApi?.data?.result?.items.filter((item)=>item.item_code == serialMatchRow.item_code);
        
        if (scannedSerial.includes(itemCode) || apiscannedSerial?.[0]?.used_serial_no?.includes(itemCode)) {
          setError(`Serial number ${itemCode} already scanned`);
          setShowError(true);
          return prevRows;
        }

        const serialItems = getSerialItemsForCode(prevRows, serialMatchRow.item_code);
        
        if (isItemFullyDistributed(serialItems)) {
          setError(`Item ${serialMatchRow.item_code} already fully distributed`);
          setShowError(true);
          return prevRows;
        }

        setScannedItemCode(serialMatchRow.item_code);

        // Try to find existing row in current bin
        const existingRowIndex = findExistingRowForSerialItem(
          prevRows, 
          itemCode, 
          currentBin.name
        );

        if (existingRowIndex !== -1) {
          setscannedSerial([...scannedSerial, itemCode]);
          setCurrentPage(1)
          return updateExistingSerialRow(
            prevRows,
            existingRowIndex,
            serialMatchRow.item_code,
            setCurrentSelectRow,
            itemCode
          );
        }

        // Find undistributed row
        const undistributedRowIndex = findUndistributedSerialRow(
          prevRows,
          itemCode
        );

        if (undistributedRowIndex === -1) {
          setError(`Cannot distribute more of item ${itemCode}`);
          setShowError(true);
          return prevRows;
        }
        setscannedSerial([...scannedSerial, itemCode]);
        setCurrentPage(1);
        return createNewDistributionForSerialItem(
          prevRows,
          undistributedRowIndex,
          serialMatchRow.item_code,
          currentBin.name,
          setCurrentSelectRow,
          itemCode
        );
      } else {
        // Handle non-serialized item scan
        const itemRows = getNonSerialItemsForCode(prevRows, itemCode);

        if (!itemRows[0]) {
          setError("Item/Serial Not Found");
          setShowError(true);
          return prevRows;
        }

        if (isItemFullyDistributed(itemRows)) {
          setError(`Item ${itemCode} already fully distributed`);
          setShowError(true);
          return prevRows;
        }

        setScannedItemCode(itemCode);

        // Try to find existing row in current bin
        const existingRowIndex = findExistingRowForItem(prevRows,itemCode,currentBin.name);

        if (existingRowIndex !== -1) {
          setCurrentPage(1);
          return updateExistingItemRow(
            prevRows,
            existingRowIndex,
            itemCode,
            setCurrentSelectRow
          );
        }

        // Find undistributed row
        const undistributedRowIndex = findUndistributedItemRow(prevRows,itemCode);

        if (undistributedRowIndex === -1) {
          setError(`Cannot distribute more of item ${itemCode}`);
          setShowError(true);
          return prevRows;
        }
        setCurrentPage(1);
        return createNewDistributionForItem(
          prevRows,
          undistributedRowIndex,
          itemCode,
          currentBin.name,
          setCurrentSelectRow
        );
      }
    });
    
    setScannedItem('');
  };

  const handleSplitItem = (rowId) => {
    setitem_Rows(prevRows => {
      const rowIndex = prevRows.findIndex(row => row.id === rowId);
      if (rowIndex === -1) return prevRows;

      const rowToSplit = prevRows[rowIndex];

      if (!rowToSplit.new_bin || rowToSplit.scan_qty === 0) {
        setError("Cannot split - item not yet distributed to any bin");
        setShowError(true);
        return prevRows;
      }

      const isLastRowForItem = !prevRows.slice(rowIndex + 1).some(
        row => row.item_code === rowToSplit.item_code
      );

      if (!isLastRowForItem) {
        setError("Can only split from the last distribution row for this item");
        setShowError(true);
        return prevRows;
      }

      const remainingQty = rowToSplit.grn_qty - rowToSplit.scan_qty;
      if (remainingQty <= 0) {
        setError("No quantity remaining to distribute");
        setShowError(true);
        return prevRows;
      }

      const newRow = {
        ...rowToSplit,
        id: `${rowToSplit.item_code}-${Date.now()}`,
        grn_qty: remainingQty,
        scan_qty: 0,
        serial_no_used:[],
        new_bin: '',
        originalData: false,
        amount: rowToSplit.rate,
        idx: rowToSplit.idx + 1
      };

      const updatedRows = [...prevRows];

      updatedRows.splice(rowIndex + 1, 0, newRow);
      for (let i = rowIndex + 2; i < updatedRows.length; i++) {
      updatedRows[i] = {
        ...updatedRows[i],
        idx: updatedRows[i].idx + 1
      };
    }
      return updatedRows;
    });
  };

  const CreatePutAway = async () => {
    try {
      const groupedItems = item_Rows.reduce((acc, item) => {
        console.log("check ietem ssss",item_Rows)
        if (!item.new_bin) return acc;
        const key = `${item.item_code}-${item.new_bin}`;
        if (!acc[key]) {
          acc[key] = {
            item_code: item.item_code,
            t_warehouse: item.new_bin,
            received_qty: item.received_qty,
            scan_qty: item.scan_qty,
            serial_no: item.serial_no_used.slice(0,item.scan_qty),
            use_serial_batch_fields: true,
            batch_no: item.batch_no,
            expiry_date: item.expiry_date
          };
        } else {
          acc[key].scan_qty += item.scan_qty;
          acc[key].serial_no.push(...item.serial_no_used);
        }
        return acc;
      }, {});
      console.log("fkfkfkfkf,,vv,v,,v,v,v",groupedItems);
    // const serialNoMap = {};
    // location.state.itemwithSerialNo.forEach((item) => {
    //   serialNoMap[item.item_code] = [...item.serial_nos];
    // });

    const payload = {
      receipt_id: location.state.Grn,
      save: true,
      items: Object.values(groupedItems)
    };

    const response = await create_putaway(payload);
    console.log("ceck respondse is heeee",response);
    if (response.error) {
      throw new Error( "Failed to create putaway");
    }

    setput_response(response.data);
    setptype("Message");
    setError("Put Away Saved Successfully");
    setShowError(true);

    setTimeout(() => {
      setShowError(false);
    }, 4000);
  } catch (err) {
    setError(err.message);
    setShowError(true);
  }
  };

  const SubmitPutAway = async () => {
    setactivityboll(false);
    const payload = { put_away_id: put_response.result };
    try {
      const ResponseData = await submit_putaway(payload)
      if (ResponseData.error) {
        setptype("Error")
        setError(ResponseData.error?.data?.message);
        setShowError(true);
      }

      setptype("Message")
      setError("Put Away Submitted Successfully");
      setactivityboll(true);
      setShowError(true);
      setfinalstep(true);


      setTimeout(() => {
        setptype("Error")
        setError("");
        setShowError(false);
        nvg('/inbound/purchaseorder/purchase-orders');
      }, 3000);


    } catch (error) {
      console.log("error", error);
    }
  }

  const scannedItemOnTop = () => {
  if (!scannedItemCode) return item_Rows;
  const matchingItems = item_Rows.filter(row => row.item_code === scannedItemCode);
  const otherItems = item_Rows.filter(row => row.item_code !== scannedItemCode)
  return [...matchingItems, ...otherItems];
  };

  return (

    <>
      <Tabs />

      <div className="d-flex justify-content-between px-2 " style={{ background: "#fcfdfe" }}>
        <div className="d-flex align-items-center customizewidth">
          <p className="m-0 breadcrumb-item">Inbound</p>
          <p className="m-0" style={{ fontSize: '12.2px' }}> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={14} /> </p>
          <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer', fontSize: '12.2px' }} onClick={() => { nvg("/inbound/putaway/create-in-putaway") }}>Put Away List </p>
          <p className="m-0">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={14} />  </p>
          <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px' }} >
            <span style={{ color: '#391F84' }}>   New Put Away</span>

            <button className={`rounded-pill ${finalstep ? 'greenbtnforstatus' : 'newdesign2343'}`} > {finalstep ? "Submitted" : put_response.result ? 'Draft' : 'New'}</button>
          </a>
        </div>

        <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }} >
          <p
            style={{ textDecoration: "none" }}
            className="custom-btn-00989 m-0"
            onClick={() => { put_response.result ? SubmitPutAway() : CreatePutAway() }}
          >
            <GetIcon iconName='LuFilePlus2' size={12} /> &nbsp;

            {put_response.result ? 'Submit' : 'Save'}
          </p>
        </div>
      </div>


      <div className="d-flex flex-column" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff", flexGrow: '1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
          <div className="d-flex justify-content-between align-items-end ">
        
          <ul
            className="nav nav-tabs"
            style={{ color: "white", border: "none", paddingTop: '4px' }}
          >
            <li className="nav-item-tab-custom d-flex pt-0 pb-0 align-items-end border-radius-top-corner" >
              <a className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
              </a>
            </li>
          </ul>

          {put_response.result && <Attachment doctype="Stock Entry"  docname={put_response.result}  /> }
          </div>
        </div>
        <div className="row d-flex justify-content-between" style={{ marginTop: '14px' }}>
          <div className="col-3 " style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px' }}>
            <Tab1 
            po={{
              grnlist,
              selectedgrn,
              setselectedgrn,
              current_op: put_response.result,
              currentdate: new Date().toISOString().split('T')[0],
              po: location?.state?.po,
              supplier: location?.state?.supplier
                  }}
            activityboll={activityboll}
            grnData={completeData}
             />
          </div>
          <div className="col-9 d-flex" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', flexDirection: 'column' }}>
            <div className="d-flex justify-content-between" style={{ gap: '5px' }}>
              <div className="d-flex" style={{ gap: '5px' }} >
                <p className="NoOfLine">No. of lines - <span style={{ color: '#2563EB' }}> {item_Rows.length}</span></p>
                <p className="TotalQty">Ordered Quantity -  <span style={{ color: '#16A34A' }}>{itemList.reduce((total, item) => { return total + Number(item?.received_qty); }, 0)}</span></p>
                <p className="ReceivedQty">Scanned Quantity -  <span style={{ color: '#EC642A' }}>{item_Rows.reduce((total, item) => { return total + Number(item?.scan_qty); }, 0)}</span></p>
              </div>

              <div className="d-flex mb-2">
                <div className="px-2 d-flex " style={{ width: '260px' }}>
                  <input type="text" className="form-control p-0 px-2"
                    id="bin-scan-input"
                    placeholder="Scan Bin"
                    value={scannedBin}
                    onChange={(e) => setScannedBin(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleBinScan(scannedBin);
                      }
                    }}
                    style={{ fontSize: '0.8rem', height: '34px' }} />
                  <span style={{ position: 'relative', left: "-28px", top: '3px', width: '0px' }}><GetIcon iconName="BsUpcScan" size={15} color="#FF8D5C" /></span>
                </div>

                <div className="px-2 d-flex " style={{ width: '260px' }}>
                  <input type="text" className="form-control p-0 px-2" placeholder="Scan Item"
                    value={scannedItem} id="item-scan-input" onChange={(e) => setScannedItem(e.target.value)}
                    onKeyDown={(e) => { if (e.key === 'Enter') { handleItemScan(scannedItem); } }}
                    disabled={!currentBin}
                    style={{ fontSize: '0.8rem', height: '34px' }} />
                  <span style={{ position: 'relative', left: "-28px", top: '3px', width: '0px' }}><GetIcon iconName="BsUpcScan" size={15} color="#FF8D5C" /></span>
                </div>
              </div>
            </div>
            <div className="tableLabel">
              <div style={{ width: '99%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
              <p style={{ color: "#1E1E1E", fontWeight: '500', marginBottom: '3px', fontSize: '15px' }}>Item Details</p>
            </div>
            <Table
            scannedSerial={{setscannedSerial,scannedSerial}}
            setitem_Rows={setitem_Rows}
            tabData={{ po: location?.state?.po, supplier: location?.state?.supplier}}
             item_Rows={scannedItemOnTop()}
              currentSelectRow={currentSelectRow}
               onSplitItem={handleSplitItem}
                currentBin={currentBin?.name || ''} />
          </div>
        </div>
      </div>

      <ApiResponseBox poptype={ptype} show={showError} errorMessage={error} onClose={() => setShowError(false)} />
    </>
  );
};

export default PurchaseForm;
